// ============================================
// App Layout Component
// Responsive layout with mobile support
// ============================================

import { Outlet } from 'react-router-dom';
import { useState } from 'react';
import { Sidebar, MobileMenuButton } from './Sidebar';

export function AppLayout() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div className="min-h-screen bg-gray-50/50">
      {/* Mobile Menu Button */}
      <MobileMenuButton onClick={() => setMobileMenuOpen(true)} />

      {/* Sidebar */}
      <Sidebar
        collapsed={sidebarCollapsed}
        setCollapsed={setSidebarCollapsed}
        mobileOpen={mobileMenuOpen}
        setMobileOpen={setMobileMenuOpen}
      />

      {/* Main Content */}
      <main
        className={`
          min-h-screen transition-all duration-300 ease-in-out
          pt-16 lg:pt-0
          lg:pl-64
          ${sidebarCollapsed ? 'lg:pl-[72px]' : 'lg:pl-64'}
        `}
      >
        <div className="p-4 sm:p-6 lg:p-8 max-w-[1800px] mx-auto">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
